export default {
  zh: {
    event_gifts: '活动礼物',
    eid_al_adha_events: '宰牲节活动',
    rules: '规则',
    days: '天',
    hours: '小时',
    minutes: '分钟',
    seconds: '秒',
    hoby_wish: 'Hoby祝愿所有用户宰牲节快乐，参与活动可以获得丰厚的奖励',
    ranking: '排名',
    reward: '奖励',
    wealth: '财富',
    charm: '魅力',
    eid_al_adha_events_button_introduction_1: '本次活动解释权归 Yayya 所有',
    eid_al_adha_events_button_introduction_2: '本活动与APPLE无关',
    rules_description6: '6.本次活动的最终解释权归Hoby所有。',
    rules_description5: '5.奖励将在活动结束后48小时内发放。',
    rules_description4: '4.比赛将于2024年6月21日沙特时间23:59结束。',
    rules_description1: '1.所有用户均可参加。',
    rules_description3:
      '3.活动期间，参与者将根据获得的礼物数量自动进入榜单，排名前三名将分别获得勋章、奖牌、活动入场券和贵族称号。',
    rules_description2: '2.您每次发送或接受活动礼物时，都会获得对应价值的活动礼物币。',
  },
  en: {
    event_gifts: 'Event gifts',
    eid_al_adha_events: 'Eid al-Adha Events',
    rules: 'Rules',
    days: 'Days',
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds',
    hoby_wish:
      'Yayya wishes all users a happy Eid al-Adha. Participating in the event will earn you generous rewards.',
    ranking: 'Ranking',
    reward: 'Reward',
    wealth: 'Wealth',
    charm: 'Charm',
    eid_al_adha_events_button_introduction_1:
      'The final interpretation right of this activity belongs to Yayya',
    eid_al_adha_events_button_introduction_2: 'This activity has nothing to do with APPLE ',
    rules_description6: '6.All rights to interpretation of this event belong to Yayya.',
    rules_description5: '5.Rewards will be sent within 48 hours after the event ends.',
    rules_description4: '4.The competition will end at 23:59 Saudi time on June 21, 2024.',
    rules_description3:
      '3.During the event, participants will be automatically entered into the list according to the number of gifts awarded, and the top three places will receive a medal, medal, entry and aristocracy for the event.',
    rules_description1: '1.All users can participate.',
    rules_description2:
      '2.Every time you send or receive a gift for an event, you will receive the corresponding value of the event gift currency.',
  },
  ar: {
    event_gifts: 'هدايا النشاط',
    eid_al_adha_events: 'حدث عيد  الأضحى',
    rules: 'القواعد',
    days: 'يوم',
    hours: 'ساعة',
    minutes: 'دقيقة',
    seconds: 'ثوان',
    hoby_wish:
      'تتمنى هوبي لجميع المستخدمين عيد أضحى سعيدًا. إن المشاركة في هذا الحدث ستكسبك مكافآت سخية.',
    ranking: 'ترتيب',
    reward: 'مكافآت',
    wealth: 'ثروة',
    charm: 'كاريزما',
    eid_al_adha_events_button_introduction_1: 'الحق النهائي في تفسير هذا النشاط يعود إلى Yayya',
    eid_al_adha_events_button_introduction_2: 'هذا النشاط ليس له علاقة بشركة APPLE',
    rules_description6: '6. جميع حقوق تفسير هذا الحدث مملوكة لشركة Yayya.',
    rules_description5: '5. سيتم إرسال المكافآت خلال 48 ساعة بعد انتهاء الحدث.',
    rules_description4: '4. سينتهي الحدث عند الساعة 23:59 بتوقيت السعودية يوم 21 يونيو 2024.',
    rules_description3:
      '3.خلال الحدث، سيتم إدخال المشاركين تلقائيًا في القائمة وفقًا لعدد الهدايا الممنوحة، وستحصل المراكز الثلاثة الأولى على ميدالية وتذاكر الحدث ودخول وأرستقراطية للحدث.',
    rules_description1: '1.يمكن لجميع المستخدمين المشاركة.',
    rules_description2:
      '2. في كل مرة ترسل أو تستلم هدية الحدث، ستتلقى القيمة المقابلة لعملة هدية الحدث.',
  },
  tr: {
    event_gifts: 'Etkinlik Hediyeleri',
    eid_al_adha_events: 'Kurban Bayramı Etkinlikleri',
    rules: 'Kural',
    days: 'Gün',
    hours: 'Saat',
    minutes: 'Dakika',
    seconds: 'Saniye',
    hoby_wish:
      'Yayya Yönetimi tüm kullanıcıların Kurban Bayramını kutluyor. Etkinliğe katılmak size cömert ödüller kazandıracaktır.',
    ranking: 'Sıralama',
    reward: 'Ödül',
    wealth: 'Zenginlik',
    charm: 'Cazibe',
    eid_al_adha_events_button_introduction_1: "Bu etkinliğin son yorumlama hakkı Yayya'e aittir.",
    eid_al_adha_events_button_introduction_2: 'Bu etkinliğin APPLE ile hiçbir ilgisi yoktur',
    rules_description6: "6.Bu etkinliğin yorumlanmasının tüm hakları Yayya'e aittir.",
    rules_description5: '5.Ödüller etkinlik sona erdikten sonra 48 saat içinde gönderilecektir.',
    rules_description4: "4.Etkinlik 21 Haziran 2024 Türkiye saatiyle 23:59'da sona erecektir.",
    rules_description1: '1.Tüm kullanıcılar katılabilir.',
    rules_description3:
      '3.Etkinlik süresince katılımcılar, verilen hediye sayısına göre otomatik olarak listeye eklenecek ve ilk üçe girenler, etkinlik için Rozet madalya, giriş ve aristokrasi alacaktır.',
    rules_description2:
      '2.Bir etkinlik için her hediye gönderdiğinizde veya aldığınızda, etkinlik hediyesi para biriminin karşılık gelen değerini alacaksınız.',
  },
  pt: {
    event_gifts: 'Presentes do evento',
    eid_al_adha_events: 'Eventos de Eid al-Adha',
    rules: 'Regras',
    days: 'Dias',
    hours: 'Horas',
    minutes: 'Minutos',
    seconds: 'Segundos',
    hoby_wish:
      'Yayya deseja a todos os usuários um feliz Eid al-Adha. Participar do evento lhe garantirá recompensas generosas.',
    ranking: 'Ranking',
    reward: 'Recompensa',
    wealth: 'Riqueza',
    charm: 'Charme',
    eid_al_adha_events_button_introduction_1:
      'O direito de interpretação final desta atividade pertence à Yayya',
    eid_al_adha_events_button_introduction_2: 'Esta atividade não tem nada a ver com a APPLE',
    rules_description6: '6. Todos os direitos de interpretação deste evento pertencem à Yayya.',
    rules_description5:
      '5. As recompensas serão enviadas dentro de 48 horas após o término do evento.',
    rules_description4:
      '4. A competição terminará às 23:59, horário da Arábia Saudita, em 21 de junho de 2024.',
    rules_description3:
      '3. Durante o evento, os participantes serão automaticamente inseridos na lista de acordo com o número de presentes enviados, e os três primeiros lugares receberão uma medalha, medalha, entrada e nobreza para o evento.',
    rules_description1: '1. Todos os usuários podem participar.',
    rules_description2:
      '2. Toda vez que você enviar ou receber um presente para o evento, você receberá o valor correspondente da moeda do presente do evento.',
  },
  id: {
    event_gifts: 'Hadiah acara',
    eid_al_adha_events: 'Acara Eid al-Adha',
    rules: 'Aturan',
    days: 'Hari',
    hours: 'Jam',
    minutes: 'Menit',
    seconds: 'Detik',
    hoby_wish:
      'Yayya mengucapkan Selamat Hari Raya Eid al-Adha kepada semua pengguna. Berpartisipasi dalam acara ini akan memberi Anda hadiah yang murah hati.',
    ranking: 'Peringkat',
    reward: 'Hadiah',
    wealth: 'Kekayaan',
    charm: 'Pesona',
    eid_al_adha_events_button_introduction_1:
      'Hak interpretasi final dari kegiatan ini milik Yayya',
    eid_al_adha_events_button_introduction_2: 'Kegiatan ini tidak ada hubungannya dengan APPLE',
    rules_description6: '6. Semua hak interpretasi acara ini milik Yayya.',
    rules_description5: '5. Hadiah akan dikirim dalam waktu 48 jam setelah acara berakhir.',
    rules_description4:
      '4. Kompetisi akan berakhir pada pukul 23:59 waktu Arab Saudi pada 21 Juni 2024.',
    rules_description3:
      '3. Selama acara, peserta akan otomatis dimasukkan ke dalam daftar berdasarkan jumlah hadiah yang diberikan, dan tiga tempat teratas akan menerima medali, medali, entri, dan bangsawan untuk acara tersebut.',
    rules_description1: '1. Semua pengguna dapat berpartisipasi.',
    rules_description2:
      '2. Setiap kali Anda mengirim atau menerima hadiah untuk acara tersebut, Anda akan menerima nilai yang sesuai dari mata uang hadiah acara.',
  },
  uz: {
    event_gifts: "Tadbir sovg'alari",
    eid_al_adha_events: 'Eid al-Adha Tadbirlari',
    rules: 'Qoidalar',
    days: 'Kunlar',
    hours: 'Soatlar',
    minutes: 'Daqiqalar',
    seconds: 'Soniyalar',
    hoby_wish:
      'Yayya barcha foydalanuvchilarga xushhol Eid al-Adha tilaklarini bildirdi. Tadbirda ishtirok etish sizga boy mukofotlarni taqdim etadi.',
    ranking: 'Reyting',
    reward: 'Mukofot',
    wealth: 'Boylik',
    charm: 'Joziba',
    eid_al_adha_events_button_introduction_1:
      'Ushbu faoliyatning yakuniy izoh huquqi Hobyga tegishli',
    eid_al_adha_events_button_introduction_2: "Ushbu faoliyat APPLE bilan aloqasi yo'q",
    rules_description6: '6. Ushbu tadbirni izohlash huquqi Hobyga tegishli.',
    rules_description5: '5. Mukofotlar tadbir tugaganidan keyin 48 soat ichida yuboriladi.',
    rules_description4: '4. Musobaqa 2024-yil 21-iyun kuni 23:59 Saudiya vaqti bilan tugaydi.',
    rules_description3:
      "3. Tadbir davomida, ishtirokchilar sovg'alar soni bo'yicha ro'yxatga kiritiladi va uchta eng yaxshi o'rin medali, medali, kirish va aristokratiya bilan taqdirlanadi.",
    rules_description1: '1. Barcha foydalanuvchilar ishtirok eta olishadi.',
    rules_description2:
      "2. Har safar siz tadbir uchun sovg'a yuborganingizda yoki olganingizda, siz tadbir sovg'a valyutasining tegishli qiymatini olasiz.",
  },
  ru: {
    event_gifts: 'Подарки события',
    eid_al_adha_events: 'События Ид аль-Адха',
    rules: 'Правила',
    days: 'Дни',
    hours: 'Часы',
    minutes: 'Минуты',
    seconds: 'Секунды',
    hoby_wish:
      'Yayya желает всем пользователям счастливого Ид аль-Адха. Участие в событии принесет вам щедрые награды.',
    ranking: 'Рейтинг',
    reward: 'Награда',
    wealth: 'Богатство',
    charm: 'Очарование',
    eid_al_adha_events_button_introduction_1:
      'Право на окончательное толкование этого мероприятия принадлежит Yayya',
    eid_al_adha_events_button_introduction_2: 'Это мероприятие не имеет отношения к APPLE',
    rules_description6: '6. Все права на толкование этого события принадлежат Yayya.',
    rules_description5: '5. Награды будут отправлены в течение 48 часов после окончания события.',
    rules_description4: '4. Конкурс закончится в 23:59 по саудовскому времени 21 июня 2024 года.',
    rules_description3:
      '3. Во время события участники автоматически попадут в список в зависимости от количества выданных подарков, и три лучших места получат медали, медали, вступление и аристократию для события.',
    rules_description1: '1. Все пользователи могут участвовать.',
    rules_description2:
      '2. Каждый раз, когда вы отправляете или получаете подарок за событие, вы получите соответствующее значение валюты подарков этого события.',
  },
  fa: {
    event_gifts: 'جوایز رویداد',
    eid_al_adha_events: 'رویدادهای عید قربان',
    rules: 'قوانین',
    days: 'روزها',
    hours: 'ساعت‌ها',
    minutes: 'دقیقه‌ها',
    seconds: 'ثانیه‌ها',
    hoby_wish:
      'Yayya برای تمام کاربران عید قربان مبارک می‌گوید. شرکت در این رویداد به شما جوایز سخاوتمندانه‌ای می‌دهد.',
    ranking: 'رتبه‌بندی',
    reward: 'پاداش',
    wealth: 'ثروت',
    charm: 'جذابیت',
    eid_al_adha_events_button_introduction_1: 'حق تفسیر نهایی این فعالیت متعلق به Yayya است.',
    eid_al_adha_events_button_introduction_2: 'این فعالیت هیچ ارتباطی با APPLE ندارد.',
    rules_description6: '6. تمامی حقوق تفسیر این رویداد متعلق به Yayya است.',
    rules_description5: '5. جوایز ظرف 48 ساعت پس از پایان رویداد ارسال خواهد شد.',
    rules_description4:
      '4. مسابقه در ساعت 23:59 به وقت سعودی در تاریخ 21 ژوئن 2024 پایان خواهد یافت.',
    rules_description3:
      '3. در طول رویداد، شرکت‌کنندگان به طور خودکار در لیست قرار می‌گیرند بر اساس تعداد جوایزی که دریافت کرده‌اند، و سه نفر برتر مدال، مدال، ورودی و اشرافی برای رویداد دریافت خواهند کرد.',
    rules_description1: '1. تمامی کاربران می‌توانند شرکت کنند.',
    rules_description2:
      '2. هر بار که شما هدیه‌ای را برای یک رویداد ارسال یا دریافت می‌کنید، معادل آن هدیه ارز رویداد را دریافت خواهید کرد.',
  },
}



// WEBPACK FOOTER //
// src/pages/activity/eid-al-Adha/lang.js